import { observer } from 'mobx-react-lite';
import Image from 'next/image';
import { SearchPlaces } from 'searchPlaces.d';
import { DEFAULT_IMAGE } from 'constants/index';
import * as styles from './PlaceCard.css';

type PlaceCardProps = {
  hasPriority?: boolean
} & SearchPlaces

function PlaceCard({
  name,
  location,
  images,
  url,
  hasPriority,
}: PlaceCardProps) {
  return (
    <a href={url} className={styles.card}>
      <div className={styles.imageWrapper}>
        <Image
          src={images?.xs || images?.lg || images?.original || DEFAULT_IMAGE}
          alt={`Banner ${name}`}
          width={0}
          height={0}
          sizes="60vw"
          priority={hasPriority}
          className={styles.bannerImage}
        />
        <Image
          src={images?.original || DEFAULT_IMAGE}
          alt={`Logo ${name}`}
          width={96}
          height={96}
          sizes="30vw"
          className={styles.logoImage}
        />
      </div>
      <div className={styles.infoContainer}>
        <h3>{name}</h3>
        <p className={styles.location}>{`${location?.city}, ${location?.state}`}</p>
      </div>
    </a>
  );
}

export default observer(PlaceCard);
